import { render, staticRenderFns } from "./MenuSections.vue?vue&type=template&id=2a3324b4&scoped=true"
import script from "./MenuSections.vue?vue&type=script&lang=js"
export * from "./MenuSections.vue?vue&type=script&lang=js"
import style0 from "./MenuSections.vue?vue&type=style&index=0&id=2a3324b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3324b4",
  null
  
)

export default component.exports